module.exports = __webpack_public_path__ + "img/lab5.16683483.png";